import { render, staticRenderFns } from "./adminSymbolsUpload.vue?vue&type=template&id=24d5a873"
import script from "./adminSymbolsUpload.vue?vue&type=script&lang=js"
export * from "./adminSymbolsUpload.vue?vue&type=script&lang=js"
import style0 from "./adminSymbolsUpload.vue?vue&type=style&index=0&id=24d5a873&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports